module.exports = __webpack_public_path__ + "static/media/thumb2-3.e26eee11.png";